<template>
  <transition name="modal">
    <div class="ls-modal" @click="close" v-show="value">
      <div class="ls-lg-margin-bottom" :class="large ? 'ls-modal-large' : 'ls-modal-box'"  @click.stop>
        <modalLoader></modalLoader>
        <slot name="content"></slot>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: ['value', 'klass', 'large'],
    methods: {
      close (e) {
        this.$emit('input', false)
      },
      addListeners () {
        var buttons = this.findButtons()
        for (var button of buttons) this.addListener(button)
      },
      addListener (button) {
        button.addEventListener('click', this.close)
      },
      findButtons () {
        var content = this.$slots.content[0]
        return document.querySelectorAll('[close-modal]', content)
      },
      addEscListener () {
        document.addEventListener('keyup', this.onKeyUpEsc)
      },
      onKeyUpEsc (event) {
        if (event.key === 'Escape') this.close()
      }
    },
    mounted () {
      this.addListeners()
      this.addEscListener()
    }
  }
</script>
<style lang="scss" scoped>
  .ls-modal {
    display: block;
    overflow-y: auto;
    transition: opacity .2s ease;
  }
  .ls-modal-box {
    position: relative;
    margin: 120px auto 40px !important;
  }
  .ls-modal-large {
    @media screen and (max-width: 992px) and (min-width: 767px) {
      width: 80%;
    }
  }
  .modal-enter {
    opacity: 0;
  }
  .modal-leave-active {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// Modal.vue?e40d90da